import { Injectable } from "@angular/core";

@Injectable()
export class ServiceBase{
    //apiBaseUrl = 'https://localhost:44310/api/';
    apiBaseUrl = 'https://fnoladminapiuat.tmhcc.com/api/';  
    //apiBaseUrl = 'http://a8b0ff18a9d4f4370b7674c1f3cafa50-1453577089.us-east-1.elb.amazonaws.com/api/';  
}